import { render } from "./responsive-image.vue?vue&type=template&id=55a13d58"
import script from "./responsive-image.vue?vue&type=script&lang=js"
export * from "./responsive-image.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/stephen-webster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__